module.exports = __webpack_public_path__ + "static/img/ccpt2.0c94c26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/ccpt/ccpt2.jpg
// module id = REMu
// module chunks = 0